import { render } from "./DbsMyReport.vue?vue&type=template&id=348bf493"
import script from "./DbsMyReport.vue?vue&type=script&lang=js"
export * from "./DbsMyReport.vue?vue&type=script&lang=js"
script.render = render

export default script